export enum RuntimeProfile {
  Display = 'display',
  Preview = 'preview'
}
